/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import usePersistentStore from "../../persistentStore";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {useMutation} from "@apollo/react-hooks";
import {ACCEPT_TEAM_INVITATION} from "../../database/queries/teamInvitationQueries";

const useStyles = makeStyles(theme => ({}));

const AcceptTeamInvitation = (props) => {
    const classes = useStyles();
    const [globalPersistentState] = usePersistentStore();
    const history = useHistory();
    let location = useLocation();
    let {teamInvitationId} = useParams();
    const [result, setResult] = useState();

    const [acceptTeamInvitation] = useMutation(ACCEPT_TEAM_INVITATION, {
        variables: {
            teamInvitationId: teamInvitationId,
        },
    });

    useEffect(() => {
        if (!globalPersistentState.me) {
            if (window.location.pathname.indexOf('/sign-') === -1) localStorage.setItem('redirectPage', JSON.stringify(location.pathname));
            console.log('## SVR acceptTeamInvitation ## changing history', '/sign-in');
            history.push('/sign-in');
        } else {
            acceptTeamInvitation()
                .then(acceptTeamInvitationResult => {
                    setResult(acceptTeamInvitationResult.data.acceptTeamInvitation.message);
                    if (acceptTeamInvitationResult.data.acceptTeamInvitation.returnCode === 0) {
                        console.log('## SVR acceptTeamInvitation ## changing history', '/dashboard');
                        history.push('/dashboard');
                    }
                })
                .catch(e => {
                    console.trace(e);
                });
        }
    }, []);

    return (
        <Container>
            <Grid container>
                <Grid item xs={12} className={classes.gridItem}>
                    {result && <Typography>
                        {result}
                    </Typography>}
                </Grid>
            </Grid>
        </Container>
    )
};

export default AcceptTeamInvitation;
